<!-- TODO: se sei admin, nell'area messaggi in alto ci dev'essere un tasto che permatte di editare.
 Nel vecchio layout c'era, nel nuovo non è disegnato ma va previsto -->
<app-hero
	[title]="auction?.auctionName"
	imageDesktop="assets/hero/auction-details-hero-3840x400.jpg"
	imageMobile="assets/hero/auction-details-hero-768x180.jpg"
/>
<div class="mt-2 mb-3 d-lg-none">
	<a
		routerLink="/private"
		class="text-uppercase text-basecolor"
	>
		<span class="simple-arrow simple-arrow-left d-inline-block align-middle"> </span>
		<span>{{ "auction.details.allAuctions" | translate }}</span>
	</a>
</div>
<div class="mh-500">
	@if (acceptedRegulation !== null) {
		@if (acceptedRegulation) {
			@if (auction) {
				@let noDamage = ["PT", "PL", "LU"].includes(auction.idMarket);
				@let noOffers = ["ES", "LU"].includes(auction.idMarket);
				@let atLeastABuyNow = anyBuyNow();
				@let itsDesktop = isDesktop();
				@let auctionStatus = utils.isExtraTime(auction) && anyExtraLots() ? "EXTRA" : auction.status;
				@let sumVehicles = singleLot.length + sumMultiVehicles;
				@let sumObserved = sumSingleObserved + sumLotsObserved;
				@let itsBlind = auction.type === "BLIND";
				<main class="mt-lg-4">
					<div class="container-xxl">
						<aside
							class="text-uppercase before-ico text-sm text-red fw-bold"
							[ngClass]="'ico-flag-' + auction.idMarket.toLowerCase()"
						>
							{{ auction.idMarket | clkBizCT: "COUNTRY" }}
						</aside>
						<div class="py-3">
							<ng-container *ngTemplateOutlet="statusTpl; context: { $implicit: auctionStatus, type: 'auction' }" />
							@if (anyBuyNow()) {
								<span
									class="ck-badge text-uppercase ms-3"
									[style.backgroundColor]="'#005f82'"
								>
									{{ "auction.details.buySoon" | translate }}
								</span>
							}
							@if (itsBlind) {
								<span
									class="ck-badge text-uppercase ms-3"
									[style.backgroundColor]="'#1b4db0'"
								>
									{{ "auctions.blind" | translate }}
								</span>
							}
						</div>
						<div>
							<div class="text-sm d-none d-lg-block">
								{{ "auction.details.untilExpiration" | translate }}
							</div>
							<div class="py-3 row">
								<div class="col-12 col-lg-3 text-center text-lg-start">
									<countdown
										[deadline]="getEndDate()"
										[timeOffset]="timeOffset"
										(expired)="closeAuction()"
										[fullView]="true"
									/>
								</div>
								<div class="col-12 col-lg-9 d-lg-flex flex-row justify-content-end pt-3 pt-lg-0">
									<span class="btn-ico btn-ico-car-before text-lightblue d-none d-lg-inline fw-bold">
										{{ sumVehicles }}
										<span class="text-basecolor">{{ (!sumVehicles || sumVehicles > 1 ? "auction.details.cars" : "auction.details.car") | translate }}</span>
									</span>
									<span class="btn-ico btn-ico-eye-before text-lightblue ms-4 d-none d-lg-inline fw-bold">
										{{ sumObserved }}
										<span class="text-basecolor">{{ (!sumObserved || sumObserved > 1 ? "auction.details.observedCars" : "auction.details.observedCar") | translate }} </span>
									</span>
									<a
										href="#"
										class="ck-link pt-lg-0"
										(click)="$event.preventDefault(); openRegulation()"
									>
										{{ "auction.details.downloadRegulation" | translate }}
									</a>
								</div>
							</div>
						</div>

						<div class="pb-3 pt-lg-3 border-top-lg-gray">
							<auction-header [auction]="auction" />
						</div>
					</div>
					<div class="grayGradient mt-4 pb-5">
						@if (!utils.isNullOrUndefined(auction?.auctionMessage)) {
							<div class="container-xxl">
								<section class="bg-white ck-shadow rounded-3 position-relative pb-5">
									<div
										#msgContainer
										class="height-transition overflow-hidden pb-4"
										[style]="{ maxHeight: (messagesOpen ? msgContainer.scrollHeight : 160) + 'px', minHeight: '160px' }"
									>
										<div class="p-2 p-lg-4">
											<h4 class="px-3 px-lg-0 m-0 text-lg">
												{{ "template.auction.message" | translate }}
											</h4>
											@if (showAuctionMessage && (isAdmin || (auction?.idDealer == user?.idDealer && user.permission === "AUCTIONEER"))) {
												<button
													type="button"
													class="btn btn-noborder btn-ico btn-ico-pencil-after position-absolute top-0 end-0 mt-2 me-2"
													(click)="$event.stopPropagation(); showAuctionMessage = false; messagesOpen = true"
												></button>
											}
										</div>
										@if (showAuctionMessage) {
											<div class="pe-2 pe-lg-4">
												<div class="row g-0">
													<div class="col-2 col-sm-1 text-center">
														<span class="p-3 bg-icon info"> </span>
													</div>
													<article class="col-10 col-sm-11">
														<div [innerHTML]="auction.auctionMessage | safeHtml"></div>
													</article>
												</div>
											</div>
											@if (!utils.isNullOrUndefined(auction?.idFileMessage)) {
												<div class="px-2 px-lg-4 pb-2 pb-lg-4">
													<button
														type="button"
														class="btn btn-noborder btn-ico btn-ico-download-before ck-link"
														(click)="$event.stopPropagation(); getFile()"
													>
														{{ "auction.details.download" | translate }}
													</button>
												</div>
											}
											<div
												class="text-center pb-3 bg-white position-absolute bottom-0 start-0 end-0"
												[class.top-gradient]="!messagesOpen"
											>
												<button
													type="button"
													class="btn btn-transparent w-100"
													(click)="messagesOpen = !messagesOpen"
												>
													{{ (messagesOpen ? "auction.details.msgShrink" : "auction.details.msgExpand") | translate }}
													<br />
													<span
														class="accordion-arrow accordion-arrow-big"
														[class.accordion-open]="messagesOpen"
													>
														<span></span>
													</span>
												</button>
											</div>
										} @else {
											<div class="col-12 px-2 px-lg-4 text-center">
												<!-- NOTE: text-center in order to center the quill-editor -->
												<quill-editor
													(click)="$event.stopPropagation()"
													[debounceTime]="500"
													[(ngModel)]="auction.auctionMessage"
												/>
											</div>
											<section class="p-2 p-lg-4">
												<div class="text-center">
													<span class="ms-3">
														<input
															hidden
															id="uploadFileID"
															type="file"
															(change)="uploadFile($event.target.files)"
														/>
														<label
															(click)="$event.stopPropagation()"
															for="uploadFileID"
															class="btn btn-noborder text-uppercase"
														>
															{{ "auction.details.uploadFile" | translate }}
														</label>
													</span>
													@if (auction?.idFileMessage) {
														<button
															type="button"
															(click)="$event.stopPropagation(); deleteAuctionFile()"
															class="btn btn-noborder text-uppercase ms-3"
														>
															{{ "auction.details.deleteAuctionFile" | translate }}
														</button>
													}
													<br class="d-lg-none" /><button
														type="button"
														(click)="$event.stopPropagation(); showAuctionMessage = true"
														class="btn btn-outline text-uppercase ms-3 mt-3 mt-lg-0"
													>
														{{ "auction.details.cancel" | translate }}
													</button>
													<button
														type="button"
														(click)="$event.stopPropagation(); saveAuctionMessage()"
														class="btn btn-blue text-uppercase ms-3 mt-3 mt-lg-0"
													>
														{{ "auction.details.save" | translate }}
													</button>
												</div>
											</section>
										}
									</div>
								</section>
							</div>
						}
					</div>
					<ng-template #cardSwitch>
						<button
							#switchBtn
							type="button"
							class="btn btn-transparent btn-ico"
							[ngClass]="listView ? 'btn-ico-cards-before' : 'btn-ico-list-before'"
							(click)="toggleListView(switchBtn)"
						></button>
					</ng-template>
					<div class="container-xxl">
						<section>
							<ng-template
								#statusTpl
								let-status
								let-endDate="endDate"
								let-type="type"
								let-tightMobile="tightMobile"
							>
								<span
									class="ck-badge text-uppercase"
									[attr.data-color]="utils.getStatusColor(status, type)"
									[class.ck-badge-tight-mobile]="tightMobile"
								>
									@if (status === "EXTRA") {
										<countdown
											[deadline]="endDate"
											[timeOffset]="timeOffset"
										/>
									} @else {
										{{ status | clkBizCT: "AUCTION_STATUS" }}
									}
								</span>
							</ng-template>
							@if (singleLot.length || multipleLot.length) {
								<div class="py-3 pb-lg-0">
									<button
										type="button"
										class="btn btn-transparent btn-ico text-uppercase"
										[ngClass]="showSearch ? 'btn-ico-eye-struck-before' : 'btn-ico-filters-before'"
										(click)="showSearch = !showSearch"
									>
										{{ (showSearch ? "auction.details.hideFilters" : "auction.details.filters") | translate }}
									</button>
								</div>

								<div
									[collapse]="!showSearch"
									[isAnimated]="true"
								>
									<app-filters
										#filtersComp
										configuration="auctionDetails"
										[singleLevel]="singleLot"
										[multiLevel]="multipleLot"
										(singleLevelChange)="onSingleLevelChange($event)"
										(multiLevelChange)="onMultiLevelChange($event)"
										[market]="auction.idMarket"
										[idAuction]="auction.idAuction"
									/>
								</div>
								<ng-template #filtersTmp />
							}

							@if (filteredSingles.length) {
								<div
									class="row g-0"
									#target1
								>
									<aside class="col-9 pt-2">
										@if (filteredSingles.length === singleLot.length) {
											<span>
												<!-- TODO: manca il numero progressivo della pagina -->
												<strong>{{ singleLot.length }}</strong>
												{{ (!singleLot.length || singleLot.length > 1 ? "auction.details.cars" : "auction.details.car") | translate | lowercase }}
												<span [innerHTML]="'auction.details.ofwhichN' | translate: { num: sumSingleObserved }"></span>
												{{ (!sumSingleObserved || sumSingleObserved > 1 ? "auction.details.observedCars" : "auction.details.observedCar") | translate | lowercase }}
											</span>
										} @else {
											@if (filteredSingles.length > 1) {
												<span [innerHTML]="'auction.details.weFoundNMatches' | translate: { num: filteredSingles.length }"></span>
											} @else {
												<span [innerHTML]="'auction.details.weFound1Match' | translate"></span>
											}
											<button
												class="ck-link focus-ring"
												(click)="filtersComp.resetFilters()"
											>
												{{ "auction.details.clearFilters" | translate }}
											</button>
										}
									</aside>
									<div class="col-3 text-end">
										<aside class="d-inline">
											<ng-container *ngTemplateOutlet="cardSwitch" />
										</aside>
									</div>
									@if (filteredSingles.length && mfSingles) {
										<div class="col-12 text-end">
											<app-paginator-rows
												[mfTable]="mfSingles"
												[rowsOnPageSet]="rowsOnPageSet"
											/>
										</div>
									}
								</div>
								<div
									[mfData]="filteredSingles"
									#mfSingles="appDataTable"
									[mfSortBy]="tableDataSingle.orderBy"
									(mfSortByChange)="saveOrderBy(false, $event)"
									[mfSortOrder]="tableDataSingle.sortOrder"
									(mfSortOrderChange)="saveSortOrder(false, $event)"
									[mfActivePage]="tableDataSingle.mfActivePage"
									[mfRowsOnPage]="tableDataSingle.rowsOnPage"
									(onPageChange)="savePaging($event, false)"
								>
									<article class="mt-3">
										@let noFieldSelected = !tableDataSingle.orderBy;
										<header
											class="car-list-heading sticky-list-heading stickyTop-l1 bg-white rounded-top-3 ck-fixed-shadow d-none mb-3 px-3"
											[ngClass]="{
												'd-lg-grid': listView,
												'car-item-nodamage': noDamage,
												'car-item-nooffers': noOffers || itsBlind
											}"
										>
											<div class="py-1 min-width-0">
												@let showStatusTriangle = noFieldSelected || tableDataSingle.orderBy === "calculatedStatus";
												<app-default-sorter
													by="calculatedStatus"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.status' | translate"
													[class.pe-4]="showStatusTriangle"
												>
													{{ "auction.details.status" | translate }}
													@if (showStatusTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											<div class="py-1 min-width-0">
												@let showBrandTriangle = noFieldSelected || tableDataSingle.orderBy === "brand";
												<app-default-sorter
													by="brand"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.brand' | translate"
													[class.pe-4]="showBrandTriangle"
												>
													{{ "auction.details.brand" | translate }}
													@if (showBrandTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											<div class="py-1 min-width-0">
												@let showModelTriangle = noFieldSelected || tableDataSingle.orderBy === "model";
												<app-default-sorter
													by="model"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.model' | translate"
													[class.pe-4]="showModelTriangle"
												>
													{{ "auction.details.model" | translate }}
													@if (showModelTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											<div class="py-1 min-width-0">
												@let showYearTriangle = noFieldSelected || tableDataSingle.orderBy === "yearMatriculation";
												<app-default-sorter
													by="yearMatriculation"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.year' | translate"
													[class.pe-4]="showYearTriangle"
												>
													{{ "auction.details.year" | translate }}
													@if (showYearTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											<div class="py-1 min-width-0">
												@let showKmTriangle = noFieldSelected || tableDataSingle.orderBy === "kilometers";
												@let milesOrKm = auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers";
												<app-default-sorter
													by="kilometers"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="milesOrKm | translate"
													[class.pe-4]="showKmTriangle"
												>
													{{ milesOrKm | translate }}
													@if (showKmTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											@if (!noDamage) {
												<div class="py-1 min-width-0">
													@let showDamageTriangle = noFieldSelected || tableDataSingle.orderBy === "damaged";
													<app-default-sorter
														by="damaged"
														class="d-inline-block align-middle mw-100 position-relative text-truncate"
														[title]="'auction.details.damage' | translate"
														[class.pe-4]="showDamageTriangle"
													>
														{{ "auction.details.damage" | translate }}
														@if (showDamageTriangle) {
															<div
																class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
																[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
															></div>
														}
													</app-default-sorter>
												</div>
											}
											<div class="py-1 min-width-0">
												@let showAreaTriangle = noFieldSelected || tableDataSingle.orderBy === "locateArea";
												<app-default-sorter
													by="locateArea"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.locateArea' | translate"
													[class.pe-4]="showAreaTriangle"
												>
													{{ "auction.details.locateArea" | translate }}
													@if (showAreaTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											@if (!(noOffers || itsBlind)) {
												<div class="py-1 min-width-0">
													@let showOffersTriangle = noFieldSelected || tableDataSingle.orderBy === "acceptedOffers";
													<app-default-sorter
														by="acceptedOffers"
														class="d-inline-block align-middle mw-100 position-relative text-truncate"
														[title]="'auction.details.offerNumber' | translate"
														[class.pe-4]="showOffersTriangle"
													>
														{{ "auction.details.offerNumber" | translate }}
														@if (showOffersTriangle) {
															<div
																class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
																[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
															></div>
														}
													</app-default-sorter>
												</div>
											}
											<div class="py-1 min-width-0">
												@let targetPrice = itsBlind ? "startPrice" : "actualPrice";
												@let showPriceTriangle = noFieldSelected || tableDataSingle.orderBy === targetPrice;
												<app-default-sorter
													[by]="targetPrice"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="(itsBlind ? 'auction.live.startPrice' : 'auction.details.offer') | translate"
													[class.pe-4]="showPriceTriangle"
												>
													{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }}
													@if (showPriceTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
										</header>
										<ul
											class="p-0 m-0"
											[ngClass]="{ 'row gx-0 gy-3 gx-lg-3': !listView }"
										>
											@let keepButtonSpace = utils.anyOpenLot(mfSingles.data);
											@for (element of mfSingles.data; track element.idVehicle) {
												@let elementClosed = utils.isLotClosed(element);
												@let currentCurrency = getCurrencySymbol(element.currency ?? "EUR", "narrow");
												<li [ngClass]="listView ? 'py-lg-1 mt-3 mt-lg-0' : 'col-12 col-lg-4'">
													<!-- TODO: dovrebbe andare in blank -->
													<!-- TODO: quando è chiusa diventa grigina (vedere figma) -->
													<a
														[routerLink]="['/', ClickarPath.PRIVATE, ClickarPath.VEHICLE_MANAGEMENT, ClickarPath.VEHICLE_DETAILS, { idVehicle: element.idVehicle }]"
														class="car-list-item text-gray rounded-3 ck-shadow p-3"
														[ngClass]="{
															'closed-list-item': elementClosed,
															'bg-white': !elementClosed,
															'car-list-item-linear py-3 px-2 px-sm-3': listView,
															'car-item-nodamage': noDamage,
															'car-item-nooffers': noOffers || itsBlind
														}"
													>
														<div
															class="auction-image"
															[class.pe-lg-2]="listView"
														>
															@if (utils.isEmpty(element?.appraisalCode)) {
																@if (utils.isEmpty(element?.idPrincipalPhoto)) {
																	<div class="icon no-foto ar-43"></div>
																} @else {
																	<img
																		loading="lazy"
																		class="vehicleImg"
																		[src]="utils.getImageUrl(element.idPrincipalPhoto)"
																	/>
																}
															} @else {
																<button
																	type="button"
																	class="btn p-0 w-100"
																	(click)="$event.preventDefault(); $event.stopPropagation(); openURL(element.imagesUrl)"
																>
																	<img
																		loading="lazy"
																		class="vehicleImg"
																		alt=""
																		[src]="element.imageUrl || wcmService.noPhotoUrl"
																	/>
																</button>
															}
														</div>
														<div
															class="auction-brand text-truncate"
															[title]="element.brand ?? ''"
															[ngClass]="listView ? 'py-lg-3 text-start ps-2 ps-sm-3 ps-lg-0' : 'text-center'"
														>
															<strong class="text-blue">{{ element.brand ?? "&nbsp;" }}</strong>
														</div>
														<div
															class="auction-model text-truncate"
															[title]="element.model ?? ''"
															[ngClass]="listView ? 'py-lg-3 text-start ps-2 ps-sm-3 ps-lg-0' : 'text-center pb-3'"
														>
															<strong>{{ element.model ?? "&nbsp;" }}</strong>
														</div>

														<div
															class="auction-tag"
															[ngClass]="listView ? 'ps-2 ps-sm-3 ps-lg-0 pt-2 py-lg-3' : 'pb-3'"
														>
															<div
																class="d-flex flex-row gap-2 flex-wrap"
																[ngClass]="{ 'justify-content-lg-start flex-lg-nowrap': listView }"
															>
																<span
																	class="d-none col text-big"
																	[class.d-lg-block]="listView"
																>
																	{{ element.yearMatriculation }}
																</span>
																<span
																	class="ck-badge btn-ico btn-ico-simple-calendar-before flex-grow-1"
																	[class.d-lg-none]="listView"
																	data-color="lightgrey"
																>
																	{{ element.yearMatriculation }}
																</span>
																<ng-template #kmtmp1>
																	@if (utils.isEmpty(element.kilometers) || element.kilometers == -1) {
																		{{ "vehicle.notAvailable" | translate }}
																	} @else {
																		{{ element.kilometers | number: "1.0-0" : "it-IT" }}
																	}
																</ng-template>
																<span
																	class="ck-badge btn-ico btn-ico-road-before flex-grow-1"
																	[class.d-lg-none]="listView"
																	data-color="lightgrey"
																>
																	<ng-container *ngTemplateOutlet="kmtmp1" />
																	{{ (auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
																</span>
																<span
																	class="d-none col text-big"
																	[class.d-lg-block]="listView"
																>
																	<ng-container *ngTemplateOutlet="kmtmp1" />
																</span>
																@if (!noDamage) {
																	<ng-template #dmgtmp>
																		@if (utils.isEmpty(element.damaged) || element?.damaged == -1) {
																			{{ "vehicle.notAvailable" | translate }}
																		} @else {
																			{{ Math.floor(element?.damaged) | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
																		}
																	</ng-template>
																	<span
																		class="ck-badge btn-ico btn-ico-danger-before flex-grow-1"
																		[class.d-lg-none]="listView"
																		data-color="lightgrey"
																	>
																		<ng-container *ngTemplateOutlet="dmgtmp" />
																	</span>
																	<span
																		class="d-none col text-big"
																		[class.d-lg-block]="listView"
																	>
																		<ng-container *ngTemplateOutlet="dmgtmp" />
																	</span>
																}
																<span
																	class="ck-badge btn-ico btn-ico-marker-before w-100"
																	[class.d-lg-none]="listView"
																	data-color="lightgrey"
																>
																	{{ element.locateArea }}
																</span>
																<span
																	class="d-none col text-big"
																	[class.d-lg-block]="listView"
																>
																	{{ element.locateArea }}
																</span>
															</div>
														</div>
														@if (!(noOffers || itsBlind)) {
															<div
																class="auction-offersnum text-end pb-lg-3"
																[ngClass]="listView ? 'text-lg-start pt-lg-3 lh-sm' : 'pt-3'"
															>
																<span [ngClass]="listView ? 'text-sm text-lg-big' : 'lh-lg'">
																	<span [class.d-lg-none]="listView">{{ "auction.details.offers" | translate }}: </span>
																	@let numOffers = element?.acceptedOffers ?? 0;
																	@if (listView) {
																		<br class="d-lg-none" />
																		<span class="d-none d-lg-inline">{{ numOffers }}</span>
																		<strong class="d-lg-none">{{ numOffers }}</strong>
																	} @else {
																		<strong>{{ numOffers }}</strong>
																	}
																</span>
															</div>
														}
														<div
															class="auction-offer d-flex justify-content-center"
															[ngClass]="listView ? 'justify-content-lg-start py-lg-3 align-items-center align-items-lg-start' : 'pb-3'"
														>
															<span
																[class.d-none]="listView"
																class="text-sm pe-1"
															>
																{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }}
															</span>
															<span
																class="lh-1"
																[class.lh-lg-base]="listView"
																><strong
																	class="text-blue"
																	[ngClass]="listView ? 'text-big text-lg-xl' : 'text-huge'"
																>
																	{{ (itsBlind ? element.startPrice : element.actualPrice) | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
																</strong>
																@if (itsBlind) {
																	@if (listView) {
																		<span class="d-lg-none">
																			<br />
																			<span class="text-sm">{{ "auction.live.startPrice" | translate }}</span>
																		</span>
																	}
																} @else {
																	<br /><span [class.text-sm]="listView">
																		{{ "auction.details.base" | translate }}:
																		<strong class="text-blue">{{
																			element?.reservePrice && utils.isNullOrUndefined(element?.basePrice)
																				? ("auction.live.reserve" | translate)
																				: (element.basePrice | number: "1.0-0" : "it-IT") + " " + currentCurrency
																		}}</strong>
																	</span>
																}
															</span>
														</div>

														<div
															class="auction-status d-flex align-items-lg-center {{ listView ? 'ps-2 ps-sm-3 ps-lg-0 pb-lg-0 py-lg-3' : 'py-3' }}"
															[ngClass]="{ 'justify-content-lg-center': listView, 'justify-content-center': !listView && (noOffers || itsBlind) }"
														>
															<ng-container
																*ngTemplateOutlet="
																	statusTpl;
																	context: {
																		$implicit: element.calculatedStatus,
																		endDate: element.dateEnd,
																		type: 'lot',
																		tightMobile: listView
																	}
																"
															>
															</ng-container>
														</div>
														<div
															class="auction-cardetails"
															[ngClass]="listView ? 'pt-lg-3 pb-lg-0 d-none d-lg-block' : 'pb-3'"
														>
															<strong> {{ "auction.details.version" | translate }}</strong
															>: {{ element.version }}
															<br />
															@if (auction.idMarket === "DE") {
																<strong>{{ "auction.details.frame" | translate }}</strong
																>: {{ element.frame }}
															} @else {
																<strong>{{ "auction.details.licensePlate" | translate }}</strong
																>: {{ element.licensePlate }}
															}
														</div>
														<div
															class="auction-buttons pt-3 d-flex flex-column gap-2 gap-lg-3 cursor-default"
															(click)="$event.preventDefault(); $event.stopPropagation()"
															[ngClass]="{ 'flex-lg-row justify-content-lg-end align-items-lg-center': listView }"
														>
															<!-- class="auction-buttons pt-3 d-flex gap-2 cursor-default"
															[ngClass]="listView ? `flex-row justify-content-lg-end align-items-center` : 'flex-column'" -->
															@if (!elementClosed || keepButtonSpace) {
																@let showBuyNow = started && element.flgClickbuy && !element.acceptedOffers;
																<!-- NOTE: In case there is a buy now button in page, other cards have an invisible (inactive) button
																as a gap in order to have the offer buttons aligned the the side cards in desktop card view. -->
																@if (showBuyNow || (itsDesktop && atLeastABuyNow && !listView)) {
																	<button
																		type="button"
																		class="btn btn-outline text-uppercase"
																		[class.invisible]="!showBuyNow || (elementClosed && keepButtonSpace)"
																		(click)="$event.preventDefault(); $event.stopPropagation(); clickAndBuy(element)"
																	>
																		<!-- class="btn btn-outline text-uppercase"
																		[ngClass]="{
																			invisible: !showBuyNow || (elementClosed && keepButtonSpace),
																			'flex-grow-1 flex-lg-grow-0': listView
																		}" -->
																		{{ "auction.details.buyNowFor" | translate }}
																		@if (showBuyNow) {
																			{{ element.clickbuyPrice }}
																			{{ currentCurrency }}
																		}
																	</button>
																}
																@if (!hasPermission("VISITOR")) {
																	<button
																		type="button"
																		class="btn {{ observed(element?.idLot) ? 'btn-outline' : 'btn-blue' }} btn-ico btn-ico-eye{{
																			observed(element?.idLot) ? '-struck' : ''
																		}}-after text-uppercase"
																		[class.invisible]="elementClosed && keepButtonSpace"
																		(click)="$event.preventDefault(); $event.stopPropagation(); observe(element)"
																	>
																		{{ (observed(element?.idLot) ? "auction.details.removeLive" : "auction.details.addLive") | translate }}
																		<!-- [ngClass]="{
																			invisible: elementClosed && keepButtonSpace,
																			'ms-auto ms-lg-0': listView
																		}"
																		(click)="$event.preventDefault(); $event.stopPropagation(); observe(element)"
																	>
																		<span [ngClass]="{ 'd-none d-lg-block': listView }">
																			{{ (observed(element?.idLot) ? "auction.details.removeLive" : "auction.details.addLive") | translate }}
																		</span> -->
																	</button>
																}
															}
														</div>
													</a>
												</li>
											}
										</ul>
									</article>
									<div class="text-center py-3">
										<app-paginator-pages
											class="d-inline-block mx-auto"
											(click)="$event.stopPropagation(); target1.scrollIntoView()"
										/>
									</div>
								</div>
							}
							@if (filteredMultiples.length) {
								<div
									class="row g-0"
									#target2
								>
									<aside class="col-9 pt-2">
										<span>
											@if (filteredMultiples.length === multipleLot.length) {
												<!-- TODO: manca il numero progressivo della pagina -->
												<strong>{{ multipleLot.length }}</strong>
												{{ (!multipleLot.length || multipleLot.length > 1 ? "auction.details.lotsIncluding" : "auction.details.lotIncluding") | translate }}
												<strong>{{ sumMultiVehicles }}</strong>
												{{ (!sumMultiVehicles || sumMultiVehicles > 1 ? "auction.details.cars" : "auction.details.car") | translate | lowercase }},
												<span [innerHTML]="'auction.details.ofwhichN' | translate: { num: sumLotsObserved }"></span>
												{{ (!sumLotsObserved || sumLotsObserved > 1 ? "auction.details.observedLots" : "auction.details.observedLot") | translate | lowercase }}
											} @else {
												@if (filteredSingles.length > 1) {
													<span [innerHTML]="'auction.details.weFoundNMatches' | translate: { num: filteredMultiples.length }"></span>
												} @else {
													<span [innerHTML]="'auction.details.weFound1Match' | translate"></span>
												}
												<button
													class="ck-link focus-ring"
													(click)="filtersComp.resetFilters()"
												>
													{{ "auction.details.clearFilters" | translate }}
												</button>
											}
										</span>
									</aside>
									<div class="col-3 text-end d-lg-none">
										<aside>
											<ng-container *ngTemplateOutlet="cardSwitch" />
										</aside>
									</div>
									@if (multipleLot?.length) {
										<div class="col-12 col-lg-3 text-end">
											<app-paginator-rows
												[mfTable]="mfMultiples"
												[rowsOnPageSet]="rowsOnPageSet"
											/>
										</div>
									}
								</div>
								<div
									[mfData]="filteredMultiples"
									#mfMultiples="appDataTable"
									[mfSortOrder]="tableDataMulti.sortOrder"
									(mfSortOrderChange)="saveSortOrder(true, $event)"
									[mfSortBy]="tableDataMulti.orderBy"
									(mfSortByChange)="saveOrderBy(true, $event)"
									[mfActivePage]="tableDataMulti.mfActivePage"
									[mfRowsOnPage]="tableDataMulti.rowsOnPage"
									(onPageChange)="savePaging($event, true)"
									class="pt-3"
								>
									<article>
										@let noFieldSelected = !tableDataMulti.orderBy;
										<header
											class="lot-list-heading sticky-list-heading stickyTop-l1 bg-white rounded-top-3 ck-fixed-shadow d-none d-lg-grid px-3"
											[class.car-item-nooffers]="noOffers || itsBlind"
										>
											<div class="py-1 min-width-0">
												@let showStatusTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.calculatedStatus";
												<app-default-sorter
													by="lotDTO.calculatedStatus"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.status' | translate"
													[class.pe-4]="showStatusTriangle"
												>
													{{ "auction.details.status" | translate }}
													@if (showStatusTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											<div class="py-1 min-width-0">
												@let showLotTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.idLot";
												<app-default-sorter
													by="lotDTO.idLot"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="'auction.details.id' | translate"
													[class.pe-4]="showLotTriangle"
												>
													{{ "auction.details.id" | translate }}
													@if (showLotTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
											@if (!(noOffers || itsBlind)) {
												<div class="py-1 min-width-0">
													@let showOffersTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.acceptedOffers";
													<app-default-sorter
														by="lotDTO.acceptedOffers"
														class="d-inline-block align-middle mw-100 position-relative text-truncate"
														[title]="'auction.details.offerNumber' | translate"
														[class.pe-4]="showOffersTriangle"
													>
														{{ "auction.details.offerNumber" | translate }}
														@if (showOffersTriangle) {
															<div
																class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
																[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
															></div>
														}
													</app-default-sorter>
												</div>
											}
											<div class="py-1 min-width-0">
												@let targetPrice = itsBlind ? "lotDTO.startPrice" : "lotDTO.actualPrice";
												@let showPriceTriangle = noFieldSelected || tableDataMulti.orderBy === targetPrice;
												<app-default-sorter
													[by]="targetPrice"
													class="d-inline-block align-middle mw-100 position-relative text-truncate"
													[title]="(itsBlind ? 'auction.live.startPrice' : 'auction.details.offer') | translate"
													[class.pe-4]="showPriceTriangle"
												>
													{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }}
													@if (showPriceTriangle) {
														<div
															class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
															[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
														></div>
													}
												</app-default-sorter>
											</div>
										</header>
										<ul class="p-0 m-0">
											@for (multiple of mfMultiples.data; track multiple.lotDTO.idLot) {
												@let multipleClosed = utils.isLotClosed(multiple.lotDTO);
												@let currentCurrency = getCurrencySymbol(multiple.vehiclesDTO[0].currency ?? "EUR", "narrow");
												<li
													class="text-gray rounded-3 ck-shadow mt-2"
													[ngClass]="multipleClosed ? 'closed-list-item' : 'bg-white'"
												>
													<div
														class="lot-list-item p-3"
														[ngClass]="{
															'lot-list-item-linear py-3 px-2 px-sm-3': listView,
															'car-item-nooffers': noOffers || itsBlind
														}"
													>
														<div
															class="auction-vendor-logo pe-lg-3"
															[class.pb-3]="listView"
														>
															@if (auction.flgMultiAuctioneer) {
																@if (!utils.isNullOrUndefined(logoAuctioneer)) {
																	<a
																		href="#"
																		(click)="$event.preventDefault(); goToAuctioneerPresentation(logoAuctioneer[auction.provenances[0]]?.idLogo)"
																	>
																		<!-- TODO: verificare che auction.provenances[0] sia corretto -->
																		<img
																			loading="lazy"
																			[src]="utils.getImageUrl(logoAuctioneer[auction.provenances[0]]?.idLogo)"
																			alt=""
																		/>
																	</a>
																}
															} @else {
																<a
																	href="#"
																	(click)="$event.preventDefault(); goToAuctioneerPresentation()"
																>
																	<img
																		loading="lazy"
																		[src]="utils.getImageUrl(auction?.smallLogo)"
																		alt=""
																	/>
																</a>
															}
														</div>
														<div
															class="auction-lot-name d-flex pb-lg-3 align-items-center"
															[ngClass]="{ 'ps-2 ps-sm-3 ps-lg-0 pb-3': listView }"
														>
															<strong class="text-big text-blue">{{ "auction.details.lot" | translate }} {{ multiple?.lotDTO?.idLot }}</strong>
														</div>
														@if (!(noOffers || itsBlind)) {
															<div class="auction-offersnum pb-3 d-flex align-items-lg-center justify-content-end justify-content-lg-start">
																<span [ngClass]="listView ? 'text-sm text-lg-big text-end text-lg-start' : 'lh-lg pt-3 pt-lg-0'">
																	<span class="d-lg-none">{{ "auction.details.offers" | translate }}:</span>
																	@let numOffers = multiple?.lotDTO?.acceptedOffers ?? 0;

																	@if (listView) {
																		<br class="d-lg-none" />
																	}
																	<strong>{{ numOffers }}</strong>
																</span>
															</div>
														}
														<div
															class="auction-offer d-flex justify-content-center justify-content-lg-start"
															[ngClass]="listView ? 'pb-3 align-items-center' : 'py-3 pt-lg-0 align-items-lg-center'"
														>
															<span
																class="text-sm pe-1"
																[ngClass]="listView ? 'd-none' : 'd-lg-none'"
															>
																{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }}
															</span>
															<span class="lh-1 lh-lg-base">
																<strong
																	class="text-blue text-lg-xl"
																	[ngClass]="listView ? 'text-big' : 'text-huge'"
																>
																	{{ (itsBlind ? multiple.lotDTO.startPrice : multiple.lotDTO.actualPrice) | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
																</strong>
																@if (itsBlind) {
																	@if (listView) {
																		<span class="d-lg-none">
																			<br />
																			<span class="text-sm">{{ "auction.live.startPrice" | translate }}</span>
																		</span>
																	}
																} @else {
																	<span class="d-none d-lg-inline">&nbsp;&nbsp;</span>
																	<br class="d-lg-none" />{{ "auction.details.base" | translate }}:
																	<strong class="text-blue">{{
																		multiple?.lotDTO?.reservePrice || utils.isNullOrUndefined(multiple?.lotDTO.basePrice)
																			? ("auction.live.reserve" | translate)
																			: (multiple.lotDTO.basePrice | number: "1.0-0" : "it-IT") + " " + currentCurrency
																	}}</strong>
																}
															</span>
														</div>
														<div
															class="auction-status py-3 pb-lg-0 d-flex align-items-lg-center justify-content-lg-center"
															[ngClass]="{
																'ps-2 ps-sm-3 ps-lg-0 pb-3': listView,
																'py-3 pt-lg-0': !listView,
																'justify-content-center': !listView && (noOffers || itsBlind)
															}"
														>
															<ng-container
																*ngTemplateOutlet="
																	statusTpl;
																	context: {
																		$implicit: multiple.lotDTO.calculatedStatus,
																		endDate: multiple.lotDTO.dateEnd,
																		type: 'lot',
																		tightMobile: listView
																	}
																"
															>
															</ng-container>
														</div>
														<div
															class="auction-showcars text-center text-lg-start"
															[ngClass]="listView ? `pt-lg-3 ${noOffers || itsBlind ? 'pb-3 pb-lg-0' : 'ps-2 ps-sm-3 ps-lg-0'}` : 'py-3 pb-lg-0'"
														>
															<button
																type="button"
																class="btn btn-outline w-100"
																(click)="
																	$event.preventDefault();
																	$event.stopPropagation();
																	(isCarListOpen(multiple?.lotDTO?.idLot) ? closeCarList : openCarList)(multiple?.lotDTO?.idLot)
																"
															>
																{{
																	(isCarListOpen(multiple.lotDTO.idLot) ? "auction.details.hideLotVehicles" : "auction.details.showNLotVehicles")
																		| translate: { carsnum: multiple.vehiclesDTO.length }
																}}
															</button>
														</div>
														<div
															class="auction-buttons d-flex flex-column gap-2 gap-lg-3 flex-lg-row justify-content-lg-end align-items-lg-center cursor-default"
															[ngClass]="listView ? 'pt-lg-3' : 'pt-3'"
															(click)="$event.preventDefault(); $event.stopPropagation()"
														>
															@if (!multipleClosed) {
																@if (started && multiple.lotDTO.flgClickbuy && !multiple.lotDTO.acceptedOffers) {
																	<button
																		type="button"
																		class="btn btn-outline text-uppercase"
																		(click)="$event.preventDefault(); $event.stopPropagation(); clickAndBuy(multiple.lotDTO)"
																	>
																		{{ "auction.details.buyNowFor" | translate }}
																		{{ multiple.lotDTO.clickbuyPrice }}
																		{{ currentCurrency }}
																	</button>
																}
																@if (!hasPermission("VISITOR")) {
																	<button
																		type="button"
																		class="btn {{ observed(multiple?.lotDTO.idLot) ? 'btn-outline' : 'btn-blue' }} btn-ico btn-ico-eye{{
																			observed(multiple?.lotDTO.idLot) ? '-struck' : ''
																		}}-after text-uppercase"
																		(click)="$event.preventDefault(); $event.stopPropagation(); observe(null, multiple)"
																	>
																		{{ (observed(multiple?.lotDTO.idLot) ? "auction.details.removeLive" : "auction.details.addLive") | translate }}
																	</button>
																}
															}
														</div>

														@if (isCarListOpen(multiple?.lotDTO?.idLot)) {
															<div
																class="auction-cars-list d-grid"
																animate.enter="accordion-enter"
																animate.leave="accordion-leave"
															>
																<ng-template #carsList>
																	<header
																		class="car-list-heading rounded-top-3 d-none d-lg-grid mb-3 px-2 px-sm-3"
																		[class.car-item-nodamage]="noDamage"
																	>
																		<div></div>
																		<div>
																			{{ "auction.details.brand" | translate }}
																		</div>
																		<div>
																			{{ "auction.details.model" | translate }}
																		</div>
																		<div>
																			{{ "auction.details.year" | translate }}
																		</div>
																		<div>
																			{{ (auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
																		</div>
																		@if (!noDamage) {
																			<div>
																				{{ "auction.details.damage" | translate }}
																			</div>
																		}
																		<div>
																			{{ "auction.details.locateArea" | translate }}
																		</div>
																	</header>
																	<ul class="p-0">
																		@for (ele of multiple.vehiclesDTO; track ele.idVehicle) {
																			<li class="mb-2">
																				<!-- TODO: dovrebbe andare in blank -->
																				<!-- TODO: quando è chiusa diventa grigina (vedere figma) -->
																				<a
																					[routerLink]="[
																						'/',
																						ClickarPath.PRIVATE,
																						ClickarPath.VEHICLE_MANAGEMENT,
																						ClickarPath.VEHICLE_DETAILS,
																						{ idVehicle: ele.idVehicle }
																					]"
																					class="car-list-item ck-fixed-shadow rounded-3 text-gray py-3 px-2 px-sm-3"
																					[class.car-item-nodamage]="noDamage"
																				>
																					<div class="auction-image pe-2">
																						@if (utils.isEmpty(ele.appraisalCode)) {
																							@if (utils.isEmpty(ele.idPrincipalPhoto)) {
																								<div class="icon no-foto ar-43"></div>
																							} @else {
																								<img
																									loading="lazy"
																									class="vehicleImg"
																									[src]="utils.getImageUrl(ele.idPrincipalPhoto)"
																								/>
																							}
																						} @else {
																							<button
																								type="button"
																								class="btn p-0 w-100"
																								(click)="$event.preventDefault(); $event.stopPropagation(); openURL(ele.imagesUrl)"
																							>
																								<img
																									loading="lazy"
																									class="vehicleImg"
																									alt=""
																									[src]="ele.imageUrl || wcmService.noPhotoUrl"
																								/>
																							</button>
																						}
																					</div>
																					<div
																						class="auction-brand text-blue py-2 text-truncate"
																						[title]="ele.brand"
																					>
																						<strong>{{ ele.brand }}</strong>
																					</div>
																					<div
																						class="auction-model py-2 text-truncate"
																						[title]="ele.model"
																					>
																						{{ ele.model }}
																					</div>
																					<div class="auction-cardetails py-2">
																						<strong>{{ "auction.details.version" | translate }}</strong
																						>: {{ ele.version }}
																						<br />
																						@if (auction.idMarket === "DE") {
																							<strong>{{ "auction.details.frame" | translate }}</strong
																							>: {{ ele.frame }}
																						} @else {
																							<strong>{{ "auction.details.licensePlate" | translate }}</strong
																							>: {{ ele.licensePlate }}
																						}
																					</div>
																					<div class="auction-tag py-2">
																						<div class="d-flex flex-row gap-2 flex-wrap flex-lg-nowrap py-2 py-lg-0">
																							<span
																								class="ck-badge btn-ico btn-ico-simple-calendar-before d-lg-none flex-grow-1"
																								data-color="lightgrey"
																							>
																								{{ ele.yearMatriculation }}
																							</span>
																							<span class="d-none d-lg-block col">
																								{{ ele.yearMatriculation }}
																							</span>
																							<ng-template #kmtmp2>
																								@if (utils.isEmpty(ele.kilometers) || ele.kilometers == -1) {
																									{{ "vehicle.notAvailable" | translate }}
																								} @else {
																									{{ ele.kilometers | number: "1.0-0" : "it-IT" }}
																								}
																							</ng-template>
																							<span
																								class="ck-badge btn-ico btn-ico-road-before d-lg-none flex-grow-1"
																								data-color="lightgrey"
																							>
																								<ng-container *ngTemplateOutlet="kmtmp2" />
																								{{ (auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
																							</span>
																							<span class="d-none d-lg-block col">
																								<ng-container *ngTemplateOutlet="kmtmp2" />
																							</span>
																							@if (!noDamage) {
																								<ng-template #dmgtmp>
																									@if (utils.isEmpty(ele.damaged) || ele?.damaged == -1) {
																										{{ "vehicle.notAvailable" | translate }}
																									} @else {
																										{{ Math.floor(ele?.damaged) | number: "1.0-0" : "it-IT" }}
																										{{ getCurrencySymbol(ele.currency ?? "EUR", "narrow") }}
																									}
																								</ng-template>
																								<span
																									class="ck-badge btn-ico btn-ico-danger-before d-lg-none flex-grow-1"
																									data-color="lightgrey"
																								>
																									<ng-container *ngTemplateOutlet="dmgtmp" />
																								</span>
																								<span class="d-none d-lg-block col">
																									<ng-container *ngTemplateOutlet="dmgtmp" />
																								</span>
																							}
																							<span
																								class="ck-badge btn-ico btn-ico-marker-before d-lg-none w-100"
																								data-color="lightgrey"
																							>
																								{{ ele.locateArea }}
																							</span>
																							<span class="d-none d-lg-block col">{{ ele.locateArea }} </span>
																						</div>
																					</div>
																				</a>
																			</li>
																		}
																	</ul>
																</ng-template>
																<div
																	class="d-none d-lg-block p-lg-3 rounded-3 mt-lg-3 bg-gray"
																	[style.minHeight]="0"
																>
																	<!-- NOTE: min-height for the animation -->
																	<ng-container *ngTemplateOutlet="carsList"> </ng-container>
																</div>

																<bottom-sheet
																	class="d-lg-none"
																	[open]="mobileCarsList === multiple.lotDTO.idLot"
																	[template]="carsList"
																	(closeClicked)="closeCarList(multiple?.lotDTO?.idLot)"
																/>
															</div>
														}
													</div>
												</li>
											}
										</ul>
									</article>
									<div class="text-center py-3">
										<app-paginator-pages
											class="d-inline-block mx-auto"
											(click)="$event.stopPropagation(); target2.scrollIntoView()"
										/>
									</div>
								</div>
							}
							@if (!(filteredSingles.length || filteredMultiples.length)) {
								<p class="text-big text-center text-blue pt-3">
									{{ "auction.details.noFilterMatch" | translate }}
									<button
										class="ck-link focus-ring"
										(click)="filtersComp.resetFilters()"
									>
										{{ "auction.details.clearFilters" | translate }}
									</button>
								</p>
							}
						</section>
					</div>
				</main>
			}
		} @else {
			<section class="mx-auto px-4 pt-5">
				<div class="text-center mt-5">
					<a
						href="#"
						class="text-xl lh-2 text-basecolor btn-ico btn-ico-download-before"
						(click)="$event.preventDefault(); openRegulation()"
					>
						{{ "auction.details.clickRegulationMessage" | translate }} {{ "auction.details.clickHere" | translate }}
					</a>
				</div>
				<div class="d-flex flex-column justify-content-center flex-lg-row gap-3 mt-3">
					<button
						type="button"
						(click)="location.back()"
						class="btn btn-outline text-uppercase"
					>
						{{ "auction.details.back" | translate }}
					</button>
					<button
						type="button"
						(click)="acceptRegulation()"
						class="btn btn-red text-uppercase"
					>
						{{ "auction.details.accept" | translate }}
					</button>
				</div>
			</section>
		}
	}
</div>
<ng-template #connectError>
	<div class="p-4">
		<button
			type="button"
			class="close-x position-absolute top-0 end-0 mt-3 me-3"
			(click)="closeTemplateModal()"
		></button>
		<p class="pt-3">
			<span class="text-big text-blue">{{ "auction.live.mqttError" | translate }}</span>
		</p>
	</div>
</ng-template>